// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6d8c917","732":"83bfc446","977":"c8d61271"}[chunkId] + ".chunk.js";
};